import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { getFeatures } from '../../../api/analysisApi';

const useAnalysisData = (subjects, setFeatureOptionsEverywhere) => {
    useEffect(() => {

        const sensorNames = [];
        const clNames = [];
        const cmlNames = [];

        const typePriority = {
            'Corrosion Loop': 1,
            'Condition Monitoring Location': 2,
            'Sensor': 3
        };

        const rowIdMap = new Map();
        subjects?.forEach(subject => {
            const { rowId, name, type } = subject;
            if (!rowIdMap.has(rowId) || typePriority[type] > typePriority[rowIdMap.get(rowId).type]) {

                rowIdMap.set(rowId, { name, type });
            }
        });


        rowIdMap.forEach(({ name, type }) => {
            if (type === 'Sensor') {
                sensorNames.push(name);
            } else if (type === 'Corrosion Loop') {
                clNames.push(name);
            } else if (type === 'Condition Monitoring Location') {
                cmlNames.push(name);
            }
        });

        getFeatures( {
            sensors: sensorNames,
            cmls: cmlNames,
            corrosionLoops: clNames
        }
        ).then((data) => {
            setFeatureOptionsEverywhere(data);
        }
        ).catch((error) => {
            setFeatureOptionsEverywhere([]);
            toast.error(`Cannot fetch Features`);
            console.error(error);
        }
        );

    }, [subjects])
};

export default useAnalysisData;